import React from "react";
import { C, Pill } from "./shared";

const TESTIMONIALS = [
  { name: "Ananya Deshpande", role: "Frontend Intern · Infotech Solutions", quote: "I built my profile, verified my React skills, and was shortlisted in under 48 hours. SkillConnect made my campus placement journey 10x easier.", color: C.green },
  { name: "Arjun Rao",        role: "EV-FML CoE Trainee · NovaFin",         quote: "The CoE badges on my profile are what stood out to recruiters. I was hired before my campus drive even started.",            color: C.navy },
  { name: "Kabir Singh",      role: "Cybersecurity Intern · BlueCloud",     quote: "The employability score told me exactly what to improve. Three weeks later I had two offers.",                                color: C.orange },
];

export default function TestimonialsSection() {
  return (
    <section className="bg-white">
      <div className="max-w-7xl mx-auto px-6 py-16 md:py-20">
        <div className="text-center max-w-2xl mx-auto">
          <Pill color={C.green}>Student stories</Pill>
          <h2 className="font-display font-black text-3xl md:text-5xl mt-3 tracking-tight" style={{ color: C.navyDeep }}>
            Real students. <span style={{ color: C.green }}>Real placements.</span>
          </h2>
        </div>
        <div className="grid md:grid-cols-3 gap-5 mt-12">
          {TESTIMONIALS.map((t, i) => (
            <div key={t.name} className="rounded-2xl border bg-white p-6 transition-all duration-300 hover:-translate-y-1 hover:shadow-lg"
              style={{ borderColor: C.rule }} data-testid={`testimonial-${i}`}>
              <div className="text-4xl leading-none" style={{ color: t.color }}>“</div>
              <p className="text-sm text-slate-700 leading-relaxed mt-2">{t.quote}</p>
              <div className="mt-5 pt-4 border-t flex items-center gap-3" style={{ borderColor: C.rule }}>
                <div className="w-10 h-10 rounded-full grid place-items-center text-white font-bold text-sm"
                  style={{ background: `linear-gradient(135deg, ${t.color} 0%, ${C.navy} 100%)` }}>
                  {t.name.split(" ").map(p => p[0]).slice(0, 2).join("")}
                </div>
                <div className="leading-tight">
                  <div className="font-bold text-sm" style={{ color: C.ink }}>{t.name}</div>
                  <div className="text-xs text-slate-500">{t.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
